import { Injectable } from "@angular/core";
import { ITradeDealActionService, CHANNEL_TRADE_ACTION } from "../ITradeDealActionService";
import {
  PRIMITIVE,
  ClientMessageBrokerFactory,
  ClientMessageBroker,
  FnArg,
  UiArguments,
  FnTransferableArg,
} from "shared/provider-webworker";
import { Subject } from "rxjs";
import { BaseReplicaActionService } from "./BaseReplicaActionService";
import * as CubiqTS from "shared/cubiq-model-multi-asset";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class TradeDealReplicaActionService
  extends BaseReplicaActionService
  implements ITradeDealActionService
{
  protected broker: ClientMessageBroker;
  modelNotificationFailureEventSubject: Subject<any> = new Subject<any>();
  protected clientRefreshPort: MessagePort = null;

  constructor(protected factory: ClientMessageBrokerFactory) {
    super();
    this.broker = this.factory.createMessageBroker(CHANNEL_TRADE_ACTION, true, true);
    this.initModelUpdateService(this.broker, this.clientRefreshPort);
  }

  confirmTrade(dealId: string, action: CubiqTS.TradeActionType): Promise<any> {
    let request = new UiArguments("confirmTrade");

    let arg1 = new FnArg(dealId, PRIMITIVE);
    let arg2 = new FnArg(action, PRIMITIVE);

    request.args = [arg1, arg2];

    return this.broker.runOnService(request, PRIMITIVE);
  }

  confirmTrades(dealIds: Array<string>, action: CubiqTS.TradeActionType): Promise<any> {
    let request = new UiArguments("confirmTrades");

    let arg1 = new FnArg(dealIds, PRIMITIVE);
    let arg2 = new FnArg(action, PRIMITIVE);

    request.args = [arg1, arg2];

    return this.broker.runOnService(request, PRIMITIVE);
  }

  cancelTrade(dealId: string, action: CubiqTS.TradeActionType): Promise<any> {
    let request = new UiArguments("cancelTrade");

    let arg1 = new FnArg(dealId, PRIMITIVE);
    let arg2 = new FnArg(action, PRIMITIVE);

    request.args = [arg1, arg2];

    return this.broker.runOnService(request, PRIMITIVE);
  }

  cancelTrades(dealIds: Array<string>, action: CubiqTS.TradeActionType): Promise<any> {
    let request = new UiArguments("cancelTrades");

    let arg1 = new FnArg(dealIds, PRIMITIVE);
    let arg2 = new FnArg(action, PRIMITIVE);

    request.args = [arg1, arg2];

    return this.broker.runOnService(request, PRIMITIVE);
  }

  addFillComment(dealId: string, action: CubiqTS.TradeActionType, comment: string): Promise<any> {
    let request = new UiArguments("cancelTrades");

    let arg1 = new FnArg(dealId, PRIMITIVE);
    let arg2 = new FnArg(action, PRIMITIVE);
    let arg3 = new FnArg(comment, PRIMITIVE);

    request.args = [arg1, arg2, arg3];

    return this.broker.runOnService(request, PRIMITIVE);
  }

  getModelNotificationFailureEventSubject(): Subject<CubiqTS.ConcreteEncodable> {
    return this.modelNotificationFailureEventSubject;
  }
}
